/* eslint-disable react/prop-types */
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Cancel } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import theme from "assets/theme";
import { useEffect, useRef, useState } from "react";
import { PaperComponent } from "../../utils/constants";

const PrintSanPham = ({ data, open, onClose }) => {
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const toolBarRef = useRef(null);
  const [printContent, setPrintContent] = useState("");
  useEffect(() => {
    let body = "";
    const date = new Date();
    if (data && data.id) {
      body = `
  <p style="text-align:center;"><strong>CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</strong></p>
  <p style="text-align:center;"><strong><u>Độc lập – Tự do – Hạnh phúc</u></strong></p>
  <p>&nbsp;</p>
  <p style="text-align:center;"><strong>BÁO CÁO TỰ ĐÁNH GIÁ VỀ SẢN PHẨM</strong></p>
  <p style="text-align:center;"><strong>Phần I</strong></p>
  <p style="text-align:center;"><strong>THÔNG TIN CHUNG</strong></p>
  <p>1. Tên chủ thể:&nbsp;${data?.chuthe_ten}</p>
  <p>2. Loại hình tổ chức:&nbsp;</p>
  <p>3. Địa chỉ:&nbsp;</p>
  <p>4. Điện thoại:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;Email:&nbsp;</p><p>5. Tên người đại diện pháp luật:</p><p>- Họ tên:&nbsp;</p><p>- Giới tính:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; Dân tộc:&nbsp;</p>
  <p>-&nbsp;Địa&nbsp;chỉ&nbsp;thường trú:&nbsp;</p>
  <p>6. Ngày thành lập/đăng&nbsp;ký&nbsp;kinh doanh:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;</p>
  <p>Số giấy đăng ký (nếu có):</p>
  <p>7. Tên&nbsp;sản&nbsp;phẩm/dịch vụ, mô tả về quy cách sản phẩm, tiêu chuẩn:</p>
  <p>-&nbsp;Tên sản phẩm:&nbsp;${data?.ten}</p>
  <p>-&nbsp;Quy cách:&nbsp;${data?.quycach}</p>
  <p>-&nbsp;Quy mô:&nbsp;${data?.quymo}</p>
  <p>-&nbsp;Tiêu chuẩn:&nbsp;${data?.tieuchuan}</p>
  <p>Đánh dấu&nbsp;(<span>&#10003;</span>) vào mục tương ứng:</p><p>a) Giấy đăng ký kinh doanh: □</p><p>b) Đã công bố chất lượng cơ sở: □</p>
  <p>c) Đã có các điều kiện sản xuất theo quy định:</p>
  <p>- Giấy đủ điều kiện vệ sinh an toàn thực phẩm theo quy định của pháp luật cho sản xuất sản phẩm: □</p>
  <p>- Giấy&nbsp;chứng&nbsp;nhận đủ điều kiện sản xuất bắt buộc theo quy định cho sản phẩm&nbsp;<i>(đối&nbsp;với các sản&nbsp;phẩm bắt&nbsp;buộc theo quy định):</i>&nbsp;□</p>
  <p>d) Đã&nbsp;có&nbsp;đăng ký sở hữu trí tuệ: □</p><p>- Giấy chứng nhận đăng ký nhãn hiệu: □</p>
  <p>- Giấy chứng nhận quyền sử dụng chỉ dẫn địa lý, nhãn hiệu tập thể, nhãn hiệu chứng nhận: □</p>
  <p>- Giấy chứng nhận đăng ký kiểu dáng công nghiệp: □</p>
  <p>- Khác (ghi rõ): …………………………………………………………………………………&nbsp;□</p>
  <p>8. Lịch sử&nbsp;hình&nbsp;thành của chủ thể (nêu các giai đoạn hình thành và phát triển):</p>
  <p>&nbsp;</p>
  <p>9. Cơ cấu tổ chức của&nbsp;chủ&nbsp;thể:</p>
  <p>&nbsp;</p>
  <p style="text-align:center;"><strong>Phần&nbsp;II</strong></p>
  <p style="text-align:center;"><strong>KẾT QUẢ THỰC HIỆN PHƯƠNG ÁN SẢN XUẤT KINH DOANH</strong></p>
  <p>Nội dung yêu cầu: Đánh giá kết quả triển khai phương án sản xuất, kinh doanh của chủ&nbsp;thể&nbsp;theo Phương án sản xuất, kinh doanh khi đăng ký tham gia Chương trình OCOP.</p>
  <p>Lưu ý: trình bày rõ một số nội dung sau:</p>
  <p>-&nbsp;Tổ chức vùng nguyên liệu, công nghệ sản xuất, sơ chế, chế biến, đóng gói sản phẩm của&nbsp;chủ&nbsp;thể.</p>
  <p>- Sự thay đổi về chất lượng sản phẩm: chất lượng, tiêu chuẩn chất lượng, bao bì, nhãn mác, hình thức đóng gói, ...</p>
  <p>- Thị trường phân phối sản phẩm.</p>
  <p>- Kết quả sản xuất, kinh doanh: doanh thu, lợi nhuận.</p>
  <p style="text-align:center;"><strong>Phần&nbsp;III</strong></p>
  <p style="text-align:center;"><strong>ĐÁNH GIÁ KẾT QUẢ THỰC HIỆN THEO BỘ TIÊU CHÍ SẢN PHẨM OCOP</strong></p>
  <p>- Căn cứ vào Bộ tiêu&nbsp;chí&nbsp;đánh giá, phân hạng&nbsp;sản&nbsp;phẩm OCOP tương&nbsp;ứng&nbsp;với sản phẩm đăng ký, chủ thể tự đánh giá về&nbsp;kết&nbsp;quả (điểm số) có thể đạt theo thứ tự từng tiêu chí.</p>
  <p>- Mô tả, chứng minh về kết quả tương ứng (mô tả, tài liệu minh chứng cho nội dung mô&nbsp;tả).</p>
  <p>- Tài liệu minh chứng kèm theo vào phụ lục của Báo&nbsp;cáo, tham khảo hướng dẫn theo bảng dưới đây:</p>
  <figure class="table">
  <table class="tableBorder">
  <tbody>
  <tr>
  <td><strong>TT</strong></td>
  <td><strong>Nội dung</strong></td>
  <td><strong>Yêu cầu</strong></td>
  </tr>
  <tr><td>-</td>
  <td><p>Giấy đăng ký kinh doanh</p></td>
  <td><p>Bản sao có công chứng, chứng minh hoạt động kinh doanh hợp pháp (đối với các đơn vị/cá nhân có đăng ký kinh doanh)</p></td>
  </tr>
  <tr>
  <td>-</td>
  <td><p>Giấy đủ điều kiện sản xuất</p></td>
  <td><p>Bản&nbsp;sao có công chứng (đối với sản phẩm cần phải có giấy chứng nhận theo quy định hiện hành)</p></td></tr><tr><td>-</td><td><p>Nguồn gốc nguyên liệu, liên kết chuỗi</p>
  </td><td>
  <p>Bản sao tài liệu: Giấy xác nhận, hợp đồng, hóa đơn...&nbsp;chứng&nbsp;minh việc mua bán nguyên vật liệu, hợp đồng, thỏa thuận liên kết</p></td>
  </tr>
  <tr>
  <td>-</td>
  <td><p>Công&nbsp;bố&nbsp;chất lượng sản phẩm</p></td>
  <td><p>Bản sao tài liệu, chứng minh chất lượng&nbsp;sản&nbsp;phẩm được công bố</p></td>
  </tr>
  <tr>
  <td>-</td>
  <td><p>Phiếu kết quả&nbsp;kiểm&nbsp;tra chỉ tiêu an toàn thực phẩm theo&nbsp;tiêu&nbsp;chuẩn công bố</p></td>
  <td><p>Bản sao tài liệu, chứng minh đạt tiêu chuẩn vệ sinh an toàn thực phẩm</p></td>
  </tr>
  <tr>
  <td>-</td>
  <td><p>Mã&nbsp;số mã vạch, tem truy xuất nguồn gốc</p></td>
  <td><p>Bản sao tài liệu,&nbsp;chứng&nbsp;minh mã, tem, sở hữu thương hiệu...</p></td>
  </tr>
  <tr><td>-</td>
  <td><p>Sở&nbsp;hữu&nbsp;trí tuệ</p></td><td><p>Giấy chứng nhận đăng ký về sở hữu trí tuệ:&nbsp;nhãn&nbsp;hiệu, chỉ dẫn địa lý,&nbsp;nhãn&nbsp;hiệu tập thể, nhãn hiệu chứng nhận, kiểu dáng,...</p></td>
  </tr>
  <tr><td>-</td>
  <td><p>Bảo vệ môi trường</p></td><td><p>Bản sao hồ sơ, thủ tục về môi trường theo quy định; hình ảnh minh&nbsp;chứng&nbsp;về thực hiện giải pháp bảo vệ môi trường</p></td>
  </tr>
  <tr><td>-</td>
  <td><p>Hệ thống quản lý chất lượng tiên tiến, kiểm soát chất lượng</p></td><td><p>Bản sao tài liệu: chứng nhận Hệ thống quản lý chất lượng tiên tiến, chứng minh hệ thống quản lý đạt tiêu chuẩn</p></td>
  </tr>
  <tr>
  <td>-</td>
  <td><p>Kế toán</p></td><td><p>Bản sao tài liệu, minh chứng hoạt động kế toán của cơ sở</p></td>
  </tr>
  <tr>
  <td>-</td>
  <td><p>Phát triển&nbsp;thị&nbsp;trường, hoạt động quảng bá, xúc tiến thương mại</p></td>
  <td><p>Bản sao tài liệu: Hợp đồng, cam kết, xác nhận&nbsp;về&nbsp;phân phối sản phẩm, xuất khẩu sản phẩm, hoạt động xúc tiến thương mại...</p></td>
  </tr>
  <tr><td>-</td>
  <td><p>Câu chuyện về sản phẩm</p></td>
  <td><p>Bản sao tờ rơi, hình ảnh, phim, ghi âm... minh&nbsp;chứng&nbsp;về câu chuyện của sản phẩm</p></td>
  </tr>
  <tr>
  <td>-</td>
  <td><p>Kế hoạch kiểm soát nội bộ</p></td>
  <td><p>Bản sao kế hoạch kiểm soát nội bộ/Hồ&nbsp;sơ minh chứng về kế hoạch kiểm soát nội bộ</p></td>
  </tr>
  <tr>
  <td>-</td>
  <td><p>Giải thưởng của sản phẩm, bình chọn của các tổ chức uy tín trong nước và quốc&nbsp;tế...</p></td>
  <td><p>Bản&nbsp;sao tài liệu, minh chứng về các thành tích, giải thưởng, bình chọn...</p></td>
  </tr>
  <tr>
  <td>-</td>
  <td><p>Công&nbsp;bố&nbsp;chất lượng sản phẩm</p></td>
  <td><p>Bản sao tài liệu, chứng minh chất lượng&nbsp;sản&nbsp;phẩm được công bố</p></td>
  </tr>
  </tbody>
  </table>
  </figure>
  <p style="text-align:center;"><strong>Phần IV</strong></p>
  <p style="text-align:center;"><strong>KẾ HOẠCH SẢN XUẤT, KINH DOANH</strong></p>
  <p>Trình bày những định hướng, kế hoạch của chủ sở hữu trong thời gian tới về phát triển sản phẩm, tổ chức sản xuất, thị trường.</p><p>&nbsp;</p>
  <figure class="tableSign">
  <table>
  <tbody>
  <tr>
  <td>&nbsp;</td>
  <td><p style="text-align:center;"><span>Quảng Nam, ngày ${date
    .getDate()
    .toString()
    .padStart(2, "0")} tháng ${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")} năm ${date.getFullYear()}</span></p>
  <p style="text-align:center;"><strong>ĐẠI DIỆN THEO PHÁP LUẬT CỦA CƠ SỞ</strong></p>
  <p style="text-align:center;">(<i>Ký, họ tên, đóng dấu</i>)</p><p>&nbsp;</p>
  <p>&nbsp;</p>
  </td>
  </tr>
  </tbody>
  </table>
  </figure>`;
    }
    setPrintContent(body);
  }, [data]);
  const handelClear = () => {
    onClose();
  };
  const handleChangeEditor = (event, editor) => {
    const data = editor.getData();
    setPrintContent(data);
  };

  const handlePrint = () => {
    const printWindow = window.open("", "");
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = printContent;

    const figureElements = tempDiv.querySelectorAll("figure");
    const lastFigureElement = figureElements[figureElements.length - 1];
    if (lastFigureElement) {
      lastFigureElement.classList.remove("table");
      lastFigureElement.classList.add("tableSign");
    }
    printWindow.document.write(
      "<html><head><title>Báo cáo tự đánh giá về sản phẩm</title>"
    );
    printWindow.document.write(
      "<style>@page { size: A4; margin: 20mm 12mm 20mm 12mm; } body { font-family: 'Times New Roman', Times, serif, Arial, sans-serif; } .tableSign{display:flex; justify-content:flex-end;} .table table{border-collapse: collapse;} .table td, .table th {border: 1px solid #121212;padding: 8px;}</style>"
    );
    printWindow.document.write("</head><body>");
    printWindow.document.write(tempDiv.innerHTML);
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.print();
  };
  //   console.log(printContent);
  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      PaperComponent={PaperComponent}
      onClose={handelClear}
      scroll="paper"
      PaperProps={{
        sx: {
          "@media (min-width: 768px)": {
            minWidth: "40rem",
          },
          height: "100%",
        },
      }}
    >
      {/* Form*/}
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          height: "100%",
        }}
      >
        {/* Tiêu đề modal - tham số title */}
        <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#ffffff" }}>
          In báo cáo tự đánh giá về sản phẩm
          <IconButton
            aria-label="close"
            onClick={handelClear}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ overflow: "auto" }}>
          <div className="bg-white">
            <div ref={toolBarRef} />
            <CKEditor
              editor={DecoupledEditor}
              data={printContent ? printContent : ""}
              onReady={(editor) => {
                if (toolBarRef.current) {
                  toolBarRef.current.appendChild(
                    editor.ui.view.toolbar.element
                  );
                }
                editor.editing.view.change((writer) => {
                  writer.setStyle(
                    "height",
                    "450px",
                    editor.editing.view.document.getRoot()
                  );
                });
              }}
              onChange={handleChangeEditor}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            color="error"
            variant="contained"
            startIcon={<PrintIcon />}
            size="small"
            onClick={handlePrint}
            sx={{
              color: "#ffffff",
              float: "right",
              mr: 1,
              backgroundColor: "red",
              ":hover": {
                backgroundColor: "red",
              },
            }}
          >
            In
          </Button>
          <Button
            type="submit"
            variant="contained"
            startIcon={<Cancel />}
            size="small"
            onClick={handelClear}
            sx={{
              color: "#ffffff",
              float: "right",
              mr: 1,
              backgroundColor: "gray",
              ":hover": {
                backgroundColor: "gray",
              },
            }}
          >
            Đóng
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default PrintSanPham;
